import axios from 'axios';
import { ApiEndpoints } from './urls';
import { drfQueryParams } from './utils';

class ObjectHistoryApi {
  static getObjectHistory(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.objectHistoryList, { params });
  }

  static getObjectHistoryThemes(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.objectHistoryThemesList, { params });
  }
}

export default ObjectHistoryApi;
